/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import React from 'react';

function CreditDebitListSkeleton() {
    return (
        <div>
            <div
                className="overflow-auto dropdown-menu relative z-10"
                style={{ maxHeight: 'calc(100vh - 298px)' }}
            >
                <table className="w-full table-auto relative animate-pulse">
                    <thead className="sticky top-0 left-0 z-[2]">
                        <tr className="bg-[#555259] h-10">
                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[180px] sticky top-0 left-0 bg-[#555259] z-[3]" scope="col">
                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                    Credit Debit Link
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[150px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Document Type
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[150px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Code
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Name
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transaction Type
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    AR No
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    AR Date
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    GST Tax Invoice No
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Narration
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Total Taxable Value
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Total Value
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[140px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Org Code
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    GST Tax Invoice Date
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[120px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Currency
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg py-[5px] px-7 min-w-[220px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Reason For Issuing Document
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...Array(10)].map((_, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]" key={`skeleton-${i}`}>
                                <td
                                    className="py-3 px-7 sticky left-0 z-[1]"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.95)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    <div className="h-4 bg-gray-200 rounded w-32" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-24 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-20 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-36 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-28 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-16 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-24 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-28 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-40 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-20 ml-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-16 ml-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-16 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-24 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-12 mx-auto" />
                                </td>
                                <td className="py-3 px-7">
                                    <div className="h-4 bg-gray-200 rounded w-32 mx-auto" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CreditDebitListSkeleton;

